import { createSelector } from '@reduxjs/toolkit'
import { State } from '../types'
import { ReceivementOverviewListState } from './ReceivementOverviewListTypes'

const selectFeature = (state: State) => state.receivementOverviewList

export const selectReceivementOverviewListState = createSelector(
  selectFeature,
  (state: ReceivementOverviewListState) => state,
)

export const selectReceivementOverviewListFilters = createSelector(
  selectFeature,
  (state: ReceivementOverviewListState) => ({
    startDate: state.startDate,
    endDate: state.endDate,
    idFc: state.idFc,
    idSupplier: state.idSupplier,
    idAr: state.idAr,
    idStatus: state.idStatus,
    invoiceNumber: state.invoiceNumber,
    invoiceKey: state.invoiceKey,
    fcActive: state.fcActive,
    page: state.page,
    pageSize: state.pageSize,
  }),
)
